module.exports = __webpack_public_path__ + "img/figmaLogo.b5eebf93.svg";